import Copyright from "@/components/Copyright";

export default function Footer() {
  return (
    <footer>
      <Copyright />
    </footer>
  );
}
